<template>
  <v-app>
    <template v-if="isLogged && $route.path !== '/'">
      <MenuSuperior />
      <MenuEsquerdo />
      <v-main>
        <div class="container">
          <div class="content">
            <router-view />
          </div>
        </div>
      </v-main>
    </template>

    <template v-else>
      <v-main class="login-main">
        <router-view />
      </v-main>
    </template>
  </v-app>
</template>


<script>
  import MenuSuperior from './components/MenuSuperior.vue';
  import { reactive, provide, computed } from 'vue';
  import { ref } from "vue";
  import { Chart, registerables } from "chart.js";
  import MenuEsquerdo from './components/MenuEsquerdo.vue';

  export default {
    name: 'App',
    components: { MenuSuperior, MenuEsquerdo },
    setup() {
      const auth = {
        isAuthenticated: computed(() => sessionStorage.getItem('isLogged') === 'true')
      };
      const globalState = reactive({ drawer: true, miniVariant: true });

      provide('auth', auth);
      provide('globalState', globalState);

      const isLogged = computed(() => auth.isAuthenticated.value);
      return { isLogged };
    }
  };


  const isDarkMode = ref(localStorage.getItem("theme") === "dark");
  document.documentElement.classList.toggle("dark-mode", isDarkMode.value);
  Chart.register(...registerables);
</script>

<style scoped>
#app {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

.container {
  display: flex;
  height: calc(100vh - 50px);
}

.content {
  flex-grow: 1;
  padding: 8px 20px 20px 20px;
  overflow: auto;
}

.login-main {
  height: 100vh;
  overflow: hidden;
  padding: 0 !important;
  margin: 0 !important;
}
</style>
